// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".awsui_file-option_ezgb4_18azq_9:not(#\\9){inline-size:100%;min-inline-size:0;display:flex;gap:var(--space-scaled-xs-x91h81, 8px)}.awsui_file-option-thumbnail_ezgb4_18azq_12:not(#\\9){margin-block-start:var(--space-static-xxs-z6w5bq, 4px);max-inline-size:60px}.awsui_file-option-thumbnail-image_ezgb4_18azq_28:not(#\\9){inline-size:100%;block-size:auto}.awsui_file-option-metadata_ezgb4_18azq_33:not(#\\9){inline-size:100%}\n", ""]);
// Exports
module.exports = exports;
